module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAABUElEQVQ4je3Vv2rUQRTF8c8vyaJBEFJsZbp0YpEmpaCNIvgGAQkoiSCKWFq4O1ZikxfQZ7AQOxtr2YhoahsrBf9gkYSox2JnZUXYuLumEDxwmZnL8OXew3BHEkOxkuRFJtd+kkdJ2k0SVcfwBh/wEPvG1wJu4elcTcxjDW3cw9aYwO1SynvodDpwe9D+uynaT5K9JJe73a4kN5OkSfIKLWzg8wTtt3AH57CIVWzO4RRu4CWuY/YA0AO8rftLeI67uIiTg0sDj7/gBK7h6AjoVzwbAq/iO17Xc/PzZvVoLb8+uz+O6uty5ZwZ9jh4jOMHWDBKuziPs1hWPYY9fJoC/O23zGFZMTNFlSP1H/xvgluHAV7BOrb+Nvi+/oexPqM/RBanBC7UdQNLpZRek+QJTmMTHyeAHsGVWulSKWUHmiRt/Rl7QTV+TAU9XC2l9AbJH8SecZQMIB0UAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiangmu.png
// module id = CIWC
// module chunks = 1